import { react2angular } from 'react2angular';
import angular from 'angular';

import VirtualTourList from './VirtualTourList';
import VirtualTourListTab from './VirtualTourListTab.tsx';

angular
  .module('bb.appointments.virtual_tour_list', ['bb.users'])
  .component(
    'bbVirtualTourList',
    react2angular(VirtualTourList, ['listingId'], ['ErrorService']),
  )
  .component(
    'bbVirtualTourListTab',
    react2angular(VirtualTourListTab, [
      'setActionTab',
      'hasVSFeatureFlag',
      'actionTab',
    ]),
    [],
  );
